import {DefaultSpawner} from '../../components/default-spawner.js';
import {Puzzle} from '../../components/puzzle.js';
import {Statistics} from '../../components/statistics.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {PowerupPerk} from '../PowerupPerk.js';

/**
 * Rainbowfruit Powerup Perk
 * The original in Unity was called `IncreaseFruitSpawnProbability`. Since it was used only once it is hard coded now.
 */
export class RainbowfruitPowerupPerk extends PowerupPerk {
    perkStat = TransactionalNames.RainbowFruitIncreaseUpgrade;
    tagToAdjust = 'Fruit';
    boardObject = ['Fruit Rainbow'];
    upgrade1 = 0.01;
    upgrade2 = 0.02;
    upgrade3 = 0.03;
    upgrade4 = 0.04;
    upgrade5 = 0.05;

    execute() {
        const addProbability = Statistics.instance.getTransactional(this.perkStat);
        let increaseProbability = 0.0;
        switch (addProbability) {
            case 1:
                increaseProbability = this.upgrade1;
                break;
            case 2:
                increaseProbability = this.upgrade2;
                break;
            case 3:
                increaseProbability = this.upgrade3;
                break;
            case 4:
                increaseProbability = this.upgrade4;
                break;
            case 5:
                increaseProbability = this.upgrade5;
                break;
            default:
                increaseProbability = 0;
                break;
        }

        // drop spawners use this
        //if (Puzzle.instance.spawner is DefaultSpawner)
        //{
        const spawner: DefaultSpawner = Puzzle.instance.spawner as DefaultSpawner;
        for (let x = 0; x < spawner.specialObjects.length; x++) {
            for (let y = 0; y < this.boardObject.length; y++) {
                if (spawner.specialObjects[x].objectToSpawn == this.boardObject[y]) {
                    spawner.specialObjects[x].spawnLikelihood += increaseProbability;
                }
            }
        }
        //}
    }
}
